<template>
  <workbenchDetail
    @cancelCallBack="cancel"
    @approvalConfirm="approvalConfirm"
    :backlogModel="backlogModel"
    :width="width"
    :isHide="isHide"
  >
    <div slot="content">
      <el-form label-width="120px" :model="dataForm" label-position="left">
        <el-form-item
          label="基础信息"
          style="background-color: #f8f8f9"
          label-width="80px"
        ></el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名："
              >{{ dataForm.Name }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="民族："
              >{{ dataForm.Nation }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="学历："
              >{{ dataForm.Education }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="电子邮箱："
              >{{ dataForm.Email }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="工作单位："
              >{{ dataForm.WorkUnit }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="特长："
              >{{ dataForm.Specialty }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="性别："
              >{{ dataForm.Sex === 0?'女':'男' }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="籍贯："
              >{{ dataForm.NativePlace }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="电话："
              >{{ dataForm.Mobile }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="身份证号："
              >{{ dataForm.IdentityNo }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="通信地址："
              >{{ dataForm.Address }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="居住属性："
              >{{dataForm.ResidentialProperty === 0?'常驻':'暂住'}}
            </el-form-item></el-col
          >
        </el-row>
        <el-form-item
          label="加入无偿献血服务队"
          style="background-color: #f8f8f9"
          label-width="200px"
        ></el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="血型："
              >{{ dataForm.BloodType }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="献血次数："
              >{{ dataForm.BloodDonationNumber }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="献血量(ml)："
              >{{ dataForm.BloodDonationCapacity }}
            </el-form-item></el-col
          >
        </el-row>
        <el-form-item
          label="参加志愿队名称"
          style="background-color: #f8f8f9"
          label-width="200px"
        ></el-form-item>
        <el-row class="basicInfo-item" v-for="(item,a) in volunteerTeam" :key="'team' + a">
            <el-col :span="1" class="item-label"><div class="radioBox">&#12288;</div></el-col>
            <el-col :span="18" class="item-value" v-if="(item!== '其他')">{{item}}</el-col>
            <el-col :span="18" class="item-value" v-else>{{item}}({{dataForm.CorpOther}})</el-col>
        </el-row> 
        <el-form-item
          label="志愿服务时间"
          style="background-color: #f8f8f9"
          label-width="200px"
        ></el-form-item>
            <el-row class="service">
                <el-col :span="3" class="border-default">时间</el-col>
                <el-col :span="3" v-for="(item,b) in week" :key="'time' + b" class="border-left">{{item}}</el-col>
            </el-row>
            <el-row class="service service-margin">
                <el-col :span="3" class="border-default">上午</el-col>
                <el-col :span="3" v-for="(item,c) in week" :key="'morning' + c" class="border-left">{{showTicks(0,item,dataForm.ApplyVolunteerService)}}</el-col>
            </el-row>
            <el-row class="service service-margin">
                <el-col :span="3" class="border-default">下午</el-col>
                <el-col :span="3" v-for="(item,d) in week" :key="'noon' + d" class="border-left">{{showTicks(1,item,dataForm.ApplyVolunteerService)}}</el-col>
            </el-row>
            <el-row class="service service-margin">
                <el-col :span="3" class="border-default">晚上</el-col>
                <el-col :span="3" v-for="(item,e) in week" :key="'night' + e" class="border-left">{{showTicks(2,item,dataForm.ApplyVolunteerService)}}</el-col>
            </el-row>
            <div style="padding-top:10px;padding-left:20px;">
                <p>一周可参加志愿服务时间：{{dataForm.TimeForWeek}}</p>
            </div>

          <el-form-item
          label="红十字志愿者誓词"
          style="background-color: #f8f8f9"
          label-width="200px"
        ></el-form-item>
          <el-row>
          <el-col :span="24">
            <el-form-item label-width="20px"
              >{{ dataForm.VolunteerPromise }}
            </el-form-item></el-col
          >
        </el-row>
      </el-form>
    </div>
  </workbenchDetail>
</template>
<script>
import workbenchDetail from "@/modules/zjrc/pages/workbench/common/workbenchDetail";
import OfUpload from "@/components/controls/of_upload/of_upload";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";
import { mapGetters } from "vuex";

export default {
  name: "audit",
  props: {
    backlogModel: {
      type: Object,
      default: null,
    },
    isHide:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      dataForm: {}, //表单对象
      fileList: [], //附件数组
      width: "55%",
      typeName: "", //分类名称
      volunteerTeam: [],
      week: ['星期一','星期二','星期三','星期四','星期五','星期六','星期日']
    };
  },
  components: {
    workbenchDetail,
    OfUpload,
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
    showSex() {
      return (data) => {
        return data == 0 ? "女" : "男";
      };
    },
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  methods: {

      showTicks(time,week,applyVolunteerService){
        const vm = this
        const morning = [1 , 3 , 5 , 7]
        const noon = [2 , 3 , 6 , 7]
        const night = [4 , 5 , 6 , 7]
        let now = []
        if(time === 0){
            now = morning
        }else if(time === 1){
            now = noon
        }else{
            now = night
        }
        if(applyVolunteerService){
            switch(week){
                case '星期一' :
                    return vm.getTicks(applyVolunteerService.Monday,now)
                case '星期二' :
                    return vm.getTicks(applyVolunteerService.Tuesday,now)
                case '星期三' :
                    return vm.getTicks(applyVolunteerService.Wednesday,now)
                case '星期四' :
                    return vm.getTicks(applyVolunteerService.Thursday,now)
                case '星期五' :
                    return vm.getTicks(applyVolunteerService.Friday,now)
                case '星期六' :
                    return vm.getTicks(applyVolunteerService.Saturday,now)
                case '星期日' :
                    return vm.getTicks(applyVolunteerService.Sunday,now)
            }
        }
    },
    getTicks(value,timeArry){
        if(timeArry.includes(value)){
            return '√'
        }else{
            return ''
        }
    },
    //初始化数据
    loadData() {
      let that = this;
      let params = { Id: that.backlogModel.BusinessId };
      api.QueryApplyVolunteerById(params).then((res) => {
        if (res.data.Code == 0) {
          that.dataForm = res.data.Data;
          if(that.dataForm.VolunteerCorps && that.dataForm.VolunteerCorps !== ''){
              that.volunteerTeam = JSON.parse(that.dataForm.VolunteerCorps)
          }
        }
      });
    },
    //取消
    cancel() {
      this.$emit("auditCallBack", null);
    },
    //提交数据
    approvalConfirm(data) {
      let params = Object.assign({}, data);
      api
        .AuditVolunteerApply(params)
        .then((res) => {
          if (res.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.$emit("auditCallBack", params);
          } else {
            this.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    },
    //加载文件
    getlistfile() {
      let that = this;
      if (that.dataForm.Files === undefined || that.dataForm.Files === null) {
        return;
      }
      let params = { Id: that.dataForm.Files };
      api.QueryBigSickApplyFileByIds(params).then((res) => {
        if (res.data.Code == 0) {
          let fileList = res.data.Data;
          fileList.forEach((item) => {
            that.fileList.push({url:item.Url,name:item.FileName});
          });
        }
      });
    },
    //下载附件
    onFilePreview(file) {
      saveAs(file.url, file.name);
    },
  },
};
</script>

<style scoped lang="scss">
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.hidePic >>> .el-upload-list__item-delete {
  display: none !important;
}
.hidePic >>> .el-icon-close {
  display: none !important;
}
.hidePic >>> .el-icon-close-tip {
  display: none !important;
}
.hideFile >>> .el-upload-list__item-delete {
  display: none !important;
}
.hideFile >>> .el-icon-close {
  display: none !important;
}
.hideFile >>> .el-icon-close-tip {
  display: none !important;
}
.el-form >>> .el-form-item__label {
  font-weight: 500;
  padding: 5px;
}
.label-title {
  padding: 10px 0;
}
.service{
  border: 1px solid rgb(219, 218, 218);
  margin: 10px 15px 0px;
  .border-left{
      padding: 5px;
      border-left: 1px solid rgb(219, 218, 218);
      text-align: center;
      height: 30px;
  }
  .border-default{
      padding: 5px;
      text-align: center;
      height: 30px;
  }
}
.service-margin{
  margin: 0px 15px;
  border-top: none;
}
.basicInfo-item{
    border-bottom: 1px dashed rgb(201, 198, 198);
    padding: 5px;
    .item-label{
        text-align: right;
        .radioBox{
            width: 10px;
            height: 10px;
            border-radius: 10px;
            background-color: red;
            float: right;
            margin: 5px;
            line-height: 20px;
        }
    }
}
</style>

<style>
.hidePic .el-upload--picture-card {
  display: none !important;
}

.hideFile .el-upload--fileList {
  display: none !important;
}
</style>